import api from './api';


interface OrganogramaDescricao {
    id: string;
    nome: string;
    sigla: string;
    descricao: string;
}


export interface IDiretoria extends OrganogramaDescricao {
    areas: Array<IArea>;
    departamentos: Array<IDepartamento>;
}

export interface IArea extends OrganogramaDescricao {
    diretoriaId: string;
    departamentos: Array<IDepartamento>;
}

export interface IDepartamento extends OrganogramaDescricao {
    diretoriaId?: string;
    areaId?: string;
}

export const getAllOrganograma = () => api.get<IDiretoria[]>(`organograma/getAllOrganograma`);